<template>
  <component :is="wrapper" :id="!isSwitch?uid:null">
    <EbSwitch v-if="isSwitch" :expanded="getValue?'true':'false'" :controls="uid" :label="label" :value="value" @input="onChange"></EbSwitch>
    
    <summary v-else @click="toggleDetails($event)" aria-expanded="false" :aria-controls="uid">{{label}}</summary>
    
    <template v-if="isSwitch">
      <component :is="groupTag" :id="uid" :class="!getValue ? 'hidden' : null">
        <legend v-if="groupTag=='fieldset'">{{legend}}</legend>
        <slot/>
      </component>
    </template>
    <slot v-else/>
  </component>
</template>

<script>
export default {
  name: "EbDisclosure",
  props: {
    label: {
      type: String,
      default: ''
    },
    isSwitch: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    groupTag: {
      type: String,
      default: null,
      required: true,
      validator: (value) => {
				return value.match(/(fieldset|div)/);
			},
    },
    legend: {
      type: String,
      default: null
    },
  },
  computed: {
    wrapper() {
      return this.isSwitch ? "div":"details"
    },
    uid() {
      return `uid_${this._uid}`
    },
    getValue() {
      return this.value
    } 
  },
  methods: {
    toggleDetails: function(event) {
      if(event.target.getAttribute('aria-expanded') == 'true') {
        event.target.setAttribute('aria-expanded', false)
      }
      else {
        event.target.setAttribute('aria-expanded', true)
      }
    },
    onChange(value) {
      this.$emit("input", value)
    },
  }
}
</script>

<style scoped>
summary {
  cursor: pointer;
}

fieldset {
  margin-top: 0 !important;
}
</style>